<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Búsqueda para actualización de datos</span>
                    </h4>
                    <div class="card-container m-b-30">
                        <div class="card-body">
                            <div class="general-label">
                                <div class="form-group">
                                    <label>Ingrese información para buscar</label>
                                    <div class="mt-3">
                                        Buscar por: <br>
                                        <select v-model="typesearch" class="form-control">
                                            <option value="nit" selected>NIT</option>
                                            <option value="dpi">DPI</option>
                                        </select>
                                    </div>
                                    <div class="mt-3">
                                        <div v-if="typesearch === 'nit'">
                                            <div class="mt-1">
                                                <span class="mt-1">Ingrese NIT</span>
                                                <input ref="searchOne" type="text" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                            </div>
                                        </div>
                                        <div v-if="typesearch === 'dpi'">
                                            <div class="mt-1">
                                                <span class="mt-1">Ingrese DPI</span>
                                                <input ref="searchOne" type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right d-flex gap-2 flex-wrap justify-content-end">
                                    <button @click="searchValue = ''; infoPersona = {}; $refs.searchOne.focus()" type="button" class="btn btn-warning btn__limpiar">Limpiar</button>
                                    <button @click="preSearch" type="button" class="btn btn-primary btn__buscar">Buscar</button>
                                </div>
                            </div>
                            <div class="searchResultContainer" v-if="typeof infoPersona.wdesres2 !== 'undefined'">
                                <div class="searchResult">
                                    <div>
                                        <h5 class="text-primary">
                                            Resultados
                                        </h5>
                                    </div>
                                    <div>
                                        <div class="row">
                                            <div class="col-12" v-if="typeof infoPersona.wnombre !== 'undefined'">
                                                <span class="font-weight-bold">Nombre:</span> {{ (infoPersona.wnombre) ? infoPersona.wnombre : 'N/D' }}
                                            </div>
                                            <div class="col-12" v-if="typeof infoPersona.wcorreo !== 'undefined'">
                                                <span class="font-weight-bold">Correo:</span> {{ (infoPersona.wcorreo) ? infoPersona.wcorreo : 'N/D' }}
                                            </div>
                                            <div class="col-12" v-if="typeof infoPersona.wtelefo2 !== 'undefined'">
                                                <span class="font-weight-bold">Teléfono:</span> {{ (infoPersona.wtelefo2) ? infoPersona.wtelefo2 : 'N/D' }}
                                            </div>
                                            <div class="col-12" v-if="typeof infoPersona.wdesres2 !== 'undefined'">
                                                <span class="font-weight-bold">Observaciones:</span> {{ (infoPersona.wdesres2) ? infoPersona.wdesres2 : 'N/D' }}
                                            </div>
                                        </div>
                                        <div>
                                            <hr>
                                            <div class="mt-3">
                                                <h5 class="text-primary">
                                                    Actualizar datos
                                                </h5>
                                                <div class="form-group text-left">
                                                    <label class="mb-1 text-primary">Correo</label>
                                                    <input type="email" class="form-control" v-model="correo">
                                                </div>
                                                <div class="form-group text-left">
                                                    <label class="mb-1 text-primary">Teléfono</label>
                                                    <input type="tel" class="form-control" v-model="telefono">
                                                </div>
                                                <div class="text-right">
                                                    <button @click="actualizarDatos" type="button" class="btn btn-primary">Realizar actualización</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--<div v-else class="text-center text-muted">
                                    No se encontró información relacionada con esta búsqueda
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";


export default {
    props: {},
    components: {
        Pago,
        //TimelineChart,
        Layout,
        //Toster,
        InicioPago
    },
    data() {
        return {
            Valid: {},
            searchExtraUno: "",
            searchExtraDos: "",
            searchValue: "",
            typesearch: "nit",
            searched: false,
            infoPersona: {},

            // para pago directo
            pagar: 0,
            nit: '',
            nombre: '',
            correo: '',
            telefono: '',

            // para pago
            pagandoref: 0,
            pagosToApply: {}
        };
    },
    mounted() {
        if (!Tools.tieneParamsBusquedaRuta(this.$route.params)) {
            return;
        }
        this.searchValue = this.$route.params.search;
        this.typesearch = this.$route.params.type;
        this.searchExtraUno = this.$route.params.extra;
        this.searchExtraDos = this.$route.params.extrados;
        this.search();
    },
    methods: {
        Numbro,
        dayjs,
        search() {

            const self = this;
            this.recobros = {};

            let url = 'actualizacion/datos?s=' + self.searchValue + '&t=' + self.typesearch;

            store.dispatch('coreShowLoading');

            API.send('GET', url, null,
                function (response) {
                    store.dispatch('coreHideLoading');

                    if (response.status) {
                        self.infoPersona = (typeof response.data === "object") ? response.data : {};
                        self.searched = true;
                    }
                    else {
                        self.searched = true;
                        alert(response.msg);
                    }

                },
                function () {
                    self.searched = true;
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                })
        },
        preSearch() {

            if (parseInt(this.searchValue) === 0 || Tools.isEmptyString(this.searchValue)) {
                return false;
            }

            if (this.typesearch === 'nit') {
                if (this.searchValue === '') {
                    alert('Ingrese todos los campos');
                    return false;
                }
                this.$router.push({path: '/actualizacion-datos/' + this.typesearch + '/' + this.searchValue});
            }
            else if (this.typesearch === 'dpi') {
                if (this.searchValue === '') {
                    alert('Ingrese todos los campos');
                    return false;
                }
                this.$router.push({path: '/actualizacion-datos/' + this.typesearch + '/' + this.searchValue});
            }
            //this.$forceUpdate();
            this.search();
        },
        showPago(requerimiento) {
            this.nit = requerimiento.nit;
            this.nombre = requerimiento.asegurado;
            this.direccion = requerimiento.direccion;
            this.pagar = requerimiento.requerimiento;
            this.poliza = requerimiento.poliza;
        },
        cancelarPago() {
            this.pagar = 0;
        },
        actualizarDatos(recobros) {

            const self = this;

            if (confirm('¿Está seguro de realizar la actualización?')) {
                API.send('POST', 'actualizacion/datos', {
                        tipo: self.typesearch,
                        search: self.searchValue,
                        correo: self.correo,
                        telefono: self.telefono,
                        nombre: self.nombre,
                    },
                    function (response) {
                        store.dispatch('coreHideLoading');

                        if (response.status) {
                            if (typeof response.data.wdesres2 !== 'undefined') {
                                alert(response.data.wdesres2);
                                self.search();
                            }
                        }
                        else {
                            alert(response.msg);
                        }
                    },
                    function () {
                        store.dispatch('coreHideLoading');
                        alert('Error al realizar actualización, por favor intente de nuevo');
                    })
            }
        }
    },
};
</script>
